import type { ParcelamentoAPI } from '../types/parcelling.types';
import { CULTURE_LABELS } from '../constants/cultures.constants';
import { CROP_STAGE_LABELS } from '../constants/cropStages.constants';
import { MONTH_LABELS, type Month, MONTHS } from '../constants/months.constants';

export const formatParcellingName = (parcelling: ParcelamentoAPI): string => {
	const name = parcelling.name || 'Novo Parcelamento';
	const culture = CULTURE_LABELS[parcelling.culture] || '';
	return culture ? `${name} - ${culture}` : name;
};

export const formatParcellingDescription = (parcelling: ParcelamentoAPI): string => {
	const culture = CULTURE_LABELS[parcelling.culture];
	const cropStage = CROP_STAGE_LABELS[parcelling.cropStage];
	if (!culture && !cropStage) return 'Preencha os dados do parcelamento';
	if (!culture) return cropStage;
	if (!cropStage) return culture;
	return `${culture} - ${cropStage}`;
};

export const formatDate = (dateString: string): string => {
	const date = new Date(dateString);
	return date.toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	});
};

export const formatDateTime = (dateString: string): string => {
	const date = new Date(dateString);
	return date.toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	});
};

export const getMonthLabel = (monthIndex: number): string => {
	const month = MONTHS[monthIndex];
	return month ? MONTH_LABELS[month] : '';
};

export const getMonthFromIndex = (index: number): Month | undefined => {
	return MONTHS[index];
};

export const formatPercentage = (value: number): string => {
	return `${value.toFixed(2).replace('.', ',')}%`;
};

export const arraysEqual = (a: string[], b: string[]): boolean => {
	if (a.length !== b.length) return false;
	const sortedA = [...a].sort((x, y) => x.localeCompare(y));
	const sortedB = [...b].sort((x, y) => x.localeCompare(y));
	return sortedA.every((val, i) => val === sortedB[i]);
};
